var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ComplaintScore',{attrs:{"value":_vm.values,"title":_vm.filter.title,"info":_vm.filter.info,"selected":_vm.selected},on:{"update":_vm.onValuesChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }